"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResponsiveCellSpacingStyles = exports.getDeviceStyles = void 0;
var _react = require("react");
var _getResponsiveSpacingStyles = require("../utils/getResponsiveSpacingStyles");
var _linaria = require("../utils/linaria");
const getDeviceStyles = (deviceConfig, device) => {
  const innerSpacingClassNames = [];
  const outerSpacingClassNames = [];
  const innerSpacing = deviceConfig.innerSpacing,
    outerSpacing = deviceConfig.outerSpacing;
  if (innerSpacing) {
    const styleKeys = Object.keys(innerSpacing);
    styleKeys.forEach(style => {
      const value = innerSpacing[style];
      if (style.toString().startsWith('spacing') && value) {
        const deviceSpacingClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value);
        innerSpacingClassNames.push(deviceSpacingClasses);
      } else if (style.toString().startsWith('offset') && value) {
        const deviceOffsetClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value, true);
        innerSpacingClassNames.push(deviceOffsetClasses);
      }
    });
  }
  if (outerSpacing) {
    const styleKeys = Object.keys(outerSpacing);
    styleKeys.forEach(style => {
      const value = outerSpacing[style];
      if (style.toString().startsWith('spacing') && value) {
        const deviceSpacingClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value);
        outerSpacingClassNames.push(deviceSpacingClasses);
      } else if (style.toString().startsWith('offset') && value) {
        const deviceOffsetClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value, true);
        outerSpacingClassNames.push(deviceOffsetClasses);
      }
    });
  }
  return {
    innerSpacingClassNames,
    outerSpacingClassNames
  };
};
exports.getDeviceStyles = getDeviceStyles;
const useResponsiveCellSpacingStyles = responsiveConfig => {
  const innerSpacingDeviceClassNames = (0, _react.useMemo)(() => [], []);
  const outerSpacingDeviceClassNames = (0, _react.useMemo)(() => [], []);
  if (responsiveConfig) {
    const deviceKeys = Object.keys(responsiveConfig);
    deviceKeys === null || deviceKeys === void 0 ? void 0 : deviceKeys.forEach(device => {
      const _getDeviceStyles = getDeviceStyles(responsiveConfig[device], device),
        innerSpacingClassNames = _getDeviceStyles.innerSpacingClassNames,
        outerSpacingClassNames = _getDeviceStyles.outerSpacingClassNames;
      innerSpacingDeviceClassNames.push(...innerSpacingClassNames);
      outerSpacingDeviceClassNames.push(...outerSpacingClassNames);
    });
  }
  return (0, _react.useMemo)(() => ({
    responsiveInnerSpacing: (0, _linaria.cx)(...innerSpacingDeviceClassNames),
    responsiveOuterSpacing: (0, _linaria.cx)(...outerSpacingDeviceClassNames)
  }), [innerSpacingDeviceClassNames, outerSpacingDeviceClassNames]);
};
exports.useResponsiveCellSpacingStyles = useResponsiveCellSpacingStyles;